import GlobalLoader from '../common/GlobalLoader';

export default function PageLoader() {
  return <GlobalLoader fullScreen size="lg" message="Loading…" />;
}
